// extracted by mini-css-extract-plugin
module.exports = {"description":"Txs_description__1Xbxm","tableContainer":"Txs_tableContainer__1sT2L"};